import api from '../../lib/api'
import assign from 'lodash.assign'

const name = 'wps-template'

export default {
  name,
  namespaced: true,
  state: {
    directory: []
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async 'data:get' ({ commit }) {
      const { data } = await api.wpsTemplate.getDirectory()
      commit('set', { directory: data })
    },
    async init ({ dispatch }) {
      await dispatch('data:get')
    }
  }
}
